import {DataTableColumn} from "mantine-datatable";
import {BillableEvent} from "../types.ts";
import {I18n} from "@aws-amplify/core";
import {StatusBadge} from "../profile/StatusBadge.tsx";
import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";

export const useTableColumns = () => {

    const columns: DataTableColumn<BillableEvent>[] = [
        {
            accessor: 'customerId',
            title: I18n.get('Customer'),
            width: '1fr',
            render: (item: BillableEvent) => item.customerId,
        },
        {
            accessor: 'channel',
            title: I18n.get('Channel'),
            width: '1fr',
            render: (item: BillableEvent) => item.channel ?? '-',
        },
        {
            accessor: 'state',
            title: I18n.get('State'),
            width: '1fr',
            render: (item: BillableEvent) => <StatusBadge status={item.state}/>,
        },
        {
            accessor: 'meteringRecordId',
            title: I18n.get('Metering Record'),
            width: '1fr',
            render: (item: BillableEvent) => item.meteringRecordId,
        },
        {
            accessor: 'emittedAt',
            title: I18n.get('Emitted At'),
            width: '1fr',
            render: (item: BillableEvent) => item.emittedAt ? formatTimestamp(item.emittedAt as string) : '-',
        },
        {
            accessor: 'lastAttemptAt',
            title: I18n.get('Last Attempt'),
            width: '1fr',
            render: (item: BillableEvent) => item.lastAttemptAt ? formatTimestamp(item.lastAttemptAt as string) : '-',
        },
    ];

    return {
        columns,
    }
}
